class Nav {
    constructor(el) {
        this.scope = el;
        this.isInline = el.closest("header") ? el.closest("header").Header.isInline : false;
        this.scope.Nav = this;
        this.trigger = el.querySelector("[data-toggle-nav]");
        this.backLink = el.querySelector("[data-back]");
        this.navOpen = false;
        this.isClosing = false;
        this.desktopViewport = 3;
        this.handleOutsideClick = (e) => {
            if (!this.scope.contains(e.target) && !this.trigger.contains(e.target)) {
                this.closeNav();
                document.removeEventListener('keyup', this.handleOutsideKey);
                document.removeEventListener('click', this.handleOutsideClick);
            }
        }
        this.handleOutsideKey = (e) => {
            if ((!this.scope.contains(e.target) && !this.trigger.contains(e.target)) || (e.key === "Escape")) {
                this.closeNav();
                document.removeEventListener('keyup', this.handleOutsideKey);
                document.removeEventListener('click', this.handleOutsideClick);
            }
        }
        this.bindEvents();
    }

    bindEvents() {
        if (this.backLink) {
            this.backLink.addEventListener("click", () => {
                this.navOpen = true;
                this.closeNav();
                this.trigger.focus();
            });
        }

        if (this.trigger) {
            this.trigger.addEventListener("click", () => {
                if (this.navOpen) {
                    this.closeNav();
                } else {
                    if(document.querySelector(".header--open") !== null){
                        //close open nav first
                        this.openNav();
                    }else{
                        this.openNav();
                    }
                }
            });
        }
    }

    closeNav() {
        if (this.isClosing || !this.navOpen) return;
        this.isClosing = true;
        this.scope.dispatchEvent(
            new Event("close", {bubbles: false})
        );
        this.scope.classList.add("nav--closing");
        this.scope.classList.remove("nav--open");
        this.navOpen = false;
        this.isClosing = false;
        setTimeout(()=>{
            this.scope.classList.remove("nav--closing");
        }, 400)
    }

    openNav() {
        if (this.navOpen) return;
        this.scope.dispatchEvent(
            new Event("open", {bubbles: false})
        );
        this.scope.classList.add("nav--open");
        this.navOpen = true;
        if (viewport() < this.desktopViewport || !this.isInline) {
            this.backLink.focus()
        }else if(this.scope.classList.contains("nav__sub")){
            setTimeout(()=> {
                this.scope.querySelector(".nav--open .nav__items a").focus();
            })
        } else if(this.scope.querySelector("[data-nav] [data-nav]")){
            this.scope.querySelectorAll("[data-nav] [data-nav] a, [data-nav] [data-nav] [data-toggle-nav]")[0].focus();
        }
        setTimeout(()=>{
          document.addEventListener('click', this.handleOutsideClick);
          document.addEventListener('keyup', this.handleOutsideKey);
        }, 100);
    }
}

document.querySelectorAll('[data-nav]').forEach((el) => {
    new Nav(el);
});
